import axios from 'axios'
// import { NEWS_FEED_API_URL } from '../../env'
import { getSessionToken } from '../session'

const NEWS_FEED_API_URL = process.env.REACT_APP_NEWS_FEED_API_URL

const GET = 'GET'
const POST = 'POST'
const DELETE = 'DELETE'
const PUT = 'PUT' // eslint-disable-line no-unused-vars
const PATCH = 'PATCH' // eslint-disable-line no-unused-vars

export async function httpRequest(method, path, payload = null) {
    return axios({
        method,
        url: `${NEWS_FEED_API_URL}/${path}`,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionToken()}`
        },
        withCredentials: true,
        data: payload || null
    }).then(res => res.data)
}

/**
 * @param {Number} groupId Group Id
 * @param {string} url RSS URL
 * @param {string} phenomenonUuid Phenomenon to which RSS URL is added
 * @return {Promise<string>} Returns uuid of the feed
 */

const newsFeedApi = {
    addNewsFeed: async (groupId, url, phenomenonUuid) => {
        // Not sure if groupId is passed as a string
        if (isNaN(parseInt(groupId))) {
            return false
        }
        const path = Number(groupId) === 0 ? 'feed' : `${groupId}/feed`
        return httpRequest(POST, path, {
            phenomenon_uuid: phenomenonUuid,
            url
        })
    },
    /**
     * @param  {Number} groupId Group Id
     * @param  {string} feedUuid Feed's uuid
     * @param  {string} phenomenonUuid Phenomenon's uuid
     * @return {Promise<Boolean>} Success
     */
    removeNewsFeed: async (groupId, feedUuid, phenomenonUuid) => {
        if (isNaN(parseInt(groupId))) {
            return false
        }
        const path = Number(groupId) === 0 ? `${feedUuid}/${phenomenonUuid}` : `${groupId}/${feedUuid}/${phenomenonUuid}`
        return httpRequest(DELETE, path).then(ok => ok)
    },
    /**
     * @param  {Number} groupId Group Id
     * @param {string} phenomenonUuid Phenomenon's uuid
     * @return {Promise<{id: string, title: string}[]>} Feed object array
     */
    getNewsFeeds: async (groupId, phenomenonUuid) => {
        return httpRequest(GET, `${groupId}/news-feeds/${phenomenonUuid}`)
    }
}

export default newsFeedApi
